import { render, staticRenderFns } from "./channel-compliance-details-approval-container.vue?vue&type=template&id=1b305756&scoped=true&lang=pug"
import script from "./channel-compliance-details-approval-container.vue?vue&type=script&lang=ts"
export * from "./channel-compliance-details-approval-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b305756",
  null
  
)

export default component.exports